// must stay first: stores created before persistState runs may never be persisted
import '@lib/state/state.init';
import React from 'react';
import ReactDOM from 'react-dom';

import { registerIcons } from '@lib/common';
import '@lib/common/assets/fonts/fonts.css';
import './resources/i18n';

import { App } from './app';

registerIcons();

ReactDOM.render(<App />, document.getElementById('root'));
